import React from "react"
// import { Link } from "gatsby"

import Layout from "../components/layout"
import HomeWelcomeArea from "../components/WelcomeArea"
import About from "../components/About"
import Features from "../components/Features"
import Services from "../components/Services"
import Clients from "../components/Clients"
import { graphql } from "gatsby"
import useWebsiteCmsContent from "../hooks/useWebsiteCmsContent"
import { localizedBlockData } from "../services/websiteCms"
// import Arrow from "../components/Arrow"

const IndexPage = ({
  data: {
    services,
    markdownRemark: {
      frontmatter: {
        title,
        lang,
        clientSection,
        stepsSection,
        description,
        forSuccessSection,
      },
    },
  },
}) => {
  const cmsPayload = useWebsiteCmsContent()
  const page = localizedBlockData(cmsPayload, "home-page", lang) || {}
  const hero = localizedBlockData(cmsPayload, "home-hero", lang) || {}

  return (
  <Layout title={page.title || title} description={page.description || description} lang={lang}>
    <HomeWelcomeArea title={page.title || title} cmsContent={hero} />
    <div className="b-homepage-content" style={{ marginBottom: "1rem", overflow: "hidden" }}>
      <div className="b-layer-main">
        <Features {...services} />
        <About stepsSection={page.stepsSection || stepsSection} />
        <Services {...(page.forSuccessSection || forSuccessSection)} />
        <Clients {...(page.clientSection || clientSection)} />
      </div>
    </div>
  </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query($slug: String!, $lang: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        description
        lang

        stepsSection {
          title
          steps {
            title
            icon
            description
          }
        }

        forSuccessSection {
          moreButton
          list {
            icon
            title
            description
          }
        }

        clientSection {
          title
        }
      }
    }
    services: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/(content/services)/.*\\\\.md$/" }
        frontmatter: {
          lang: { eq: $lang }
          path: { nin: ["services", "ar/services"] }
        }
      }
    ) {
      edges {
        node {
          frontmatter {
            icon
            title
            description
            serviceKey
          }
        }
      }
    }
  }
`
